import React from "react";
import Chip from "../Chip";
import { grey } from "@mui/material/colors";
import MUIAvatar from "@mui/material/Avatar";
import ProductType from "../../Utility/Crud/ProductType";

export default class ChipProductType extends Chip {
  /**
   * Renders a MUI Avatar.
   */
  renderAvatar() {
    const color =
      this.props.productType || this.props.hasSelection
        ? ProductType.getColor()
        : grey[500];
    const avatarColor = this.props.isTransparent ? "transparent" : color;
    const iconColor = this.props.isTransparent ? color : "#fff";

    return (
      <MUIAvatar sx={{ bgcolor: avatarColor }}>
        {ProductType.getIcon({ fontSize: "small", sx: { color: iconColor } })}
      </MUIAvatar>
    );
  }

  /**
   * @return {string} The productType name.
   */
  getLabel() {
    return this.props.productType
      ? ProductType.getDisplayName(this.props.productType)
      : this.props.nullLabel || "None";
  }
}
